import { render, staticRenderFns } from "./VotingCard.vue?vue&type=template&id=1b02576d&scoped=true"
import script from "./VotingCard.vue?vue&type=script&lang=js"
export * from "./VotingCard.vue?vue&type=script&lang=js"
import style0 from "./VotingCard.vue?vue&type=style&index=0&id=1b02576d&prod&scoped=true&lang=css"
import style1 from "./VotingCard.vue?vue&type=style&index=1&id=1b02576d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02576d",
  null
  
)

export default component.exports